// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","fontNormal":"_2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","colorBlackA03":"rgba(14, 19, 24, 0.03)","colorBlackA07":"rgba(14, 19, 24, 0.07)","colorBlackA20":"rgba(14, 19, 24, 0.2)","title":"_31y5DEq2gAAtOYHTJLHf16","container":"_1B9R7Br1e61UG-OZxH5vE-","button":"_28IlKJsfQQNmCdRUgGe9TX","infoContainer":"_1_XjMpmeWhIeOxs5b3eoYW","mediaContainer":"_3xNE3e2rt-9RAhL40l1K3t","mediaPrimary":"_3mzRkHkv84xYNCVpc2CG0F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/updateBookmarkPage/updateBookmarkPage.css
// module id = 1064
// module chunks = 0